import React, { useState, useEffect, useRef } from 'react';
import {
  Grid,
  GridItem,
  FormControl,
  Input,
  useColorModeValue,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Checkbox,
  Textarea,
} from '@chakra-ui/react';
import '../../../../../theme/theme';

const ScreenMasterForm = ({ isOpen, onClose, handleSave, isEditMode }) => {
  const [currentRow, setCurrentRow] = useState({});
  const [focusedInput, setFocusedInput] = useState('');
  const textColor = useColorModeValue('gray.800', 'white');

  const handleFocus = (id) => {
    setFocusedInput(id);
  };

  const handleBlur = () => {
    setFocusedInput('');
  };

  const nameInputRef = useRef();
  useEffect(() => {
    setTimeout(() => {
        nameInputRef.current?.focus();
    }, 100); // small delay sometimes helps
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl">
      <ModalOverlay />
      <ModalContent
        bg={useColorModeValue('white', '#2d3748')}
        color={useColorModeValue('gray.800', 'white')}
        borderRadius="20px"
        p={0}
        mx="15px"
        // mt={{base:"45%", md: "25%", xl: "15%"}}
        boxShadow="lg"
      >
        <ModalHeader fontSize="20px" fontWeight="600" mb={{ base: 0, xl: 4 }}>
          {isEditMode ? 'Edit Screen' : 'Add New Screen'}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Grid templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)", xl: "repeat(2, 1fr)" }} gap={6}>
            <GridItem>
              <FormControl>
                <div
                  style={{
                    position: 'relative',
                    height: '50px',
                    marginTop: '5px',
                  }}
                >
                  <Input
                    id="name"
                    placeholder="Enter name"
                    value={currentRow?.name || ''}
                    ref={nameInputRef}
                    onChange={(e) =>
                      setCurrentRow({ ...currentRow, name: e.target.value })
                    }
                    color={textColor}
                    bg={useColorModeValue('gray.100', '#2d3748')}
                    borderRadius="12px"
                    _placeholder={{ color: 'transparent' }}
                    fontSize="18px"
                    height="50px"
                    px="20px"
                    onFocus={() => handleFocus('name')}
                    onBlur={handleBlur}
                  />
                  <label
                    htmlFor="name"
                    style={{
                      position: 'absolute',
                      top:
                        focusedInput === 'name' ||
                        (currentRow?.name ? true : false)
                          ? '-10px'
                          : '15px',
                      left: '15px',
                      transform:
                        focusedInput === 'name' ||
                        (currentRow?.name ? true : false)
                          ? 'translateX(10px) scale(0.75)'
                          : 'translateX(0) scale(1)',
                      color: textColor,
                      transition: 'transform 200ms, color 200ms',
                      pointerEvents: 'none',
                      zIndex: 100,
                      height: '25px',
                      width: 'auto',
                      backgroundColor: useColorModeValue('white', '#2d3748'),
                      borderRadius: '2vh',
                      display: 'inline-block',
                      paddingLeft: 10,
                      paddingRight: 10,
                    }}
                  >
                    NAME
                  </label>
                </div>
              </FormControl>
            </GridItem>

            <GridItem>
              <FormControl>
                <div
                  style={{
                    position: 'relative',
                    height: '50px',
                    marginTop: '5px',
                  }}
                >
                  <Input
                    id="item"
                    placeholder="Enter Item"
                    value={currentRow?.item || ''}
                    onChange={(e) =>
                      setCurrentRow({ ...currentRow, item: e.target.value })
                    }
                    color={textColor}
                    bg={useColorModeValue('gray.100', '#2d3748')}
                    borderRadius="12px"
                    _placeholder={{ color: 'transparent' }}
                    fontSize="18px"
                    height="50px"
                    px="20px"
                    onFocus={() => handleFocus('item')}
                    onBlur={handleBlur}
                  />
                  <label
                    htmlFor="item"
                    style={{
                      position: 'absolute',
                      top:
                        focusedInput === 'item' ||
                        (currentRow?.item ? true : false)
                          ? '-10px'
                          : '15px',
                      left: '15px',
                      transform:
                        focusedInput === 'item' ||
                        (currentRow?.item ? true : false)
                          ? 'translateX(10px) scale(0.75)'
                          : 'translateX(0) scale(1)',
                      color: textColor,
                      transition: 'transform 200ms, color 200ms',
                      pointerEvents: 'none',
                      zIndex: 100,
                      height: '25px',
                      width: 'auto',
                      backgroundColor: useColorModeValue('white', '#2d3748'),
                      borderRadius: '2vh',
                      display: 'inline-block',
                      paddingLeft: 10,
                      paddingRight: 10,
                    }}
                  >
                    ITEM
                  </label>
                </div>
              </FormControl>
            </GridItem>

            <GridItem>
              <FormControl>
                <div
                  style={{
                    position: 'relative',
                    height: '50px',
                    marginTop: '5px',
                  }}
                >
                  <Input
                    id="cut"
                    type='number'
                    placeholder="Enter Cut"
                    value={currentRow?.cut || ''}
                    onChange={(e) =>
                      setCurrentRow({ ...currentRow, cut: e.target.value })
                    }
                    color={textColor}
                    bg={useColorModeValue('gray.100', '#2d3748')}
                    borderRadius="12px"
                    _placeholder={{ color: 'transparent' }}
                    fontSize="18px"
                    height="50px"
                    px="20px"
                    onFocus={() => handleFocus('cut')}
                    onBlur={handleBlur}
                  />
                  <label
                    htmlFor="cut"
                    style={{
                      position: 'absolute',
                      top:
                        focusedInput === 'cut' ||
                        (currentRow?.cut ? true : false)
                          ? '-10px'
                          : '15px',
                      left: '15px',
                      transform:
                        focusedInput === 'cut' ||
                        (currentRow?.cut ? true : false)
                          ? 'translateX(10px) scale(0.75)'
                          : 'translateX(0) scale(1)',
                      color: textColor,
                      transition: 'transform 200ms, color 200ms',
                      pointerEvents: 'none',
                      zIndex: 100,
                      height: '25px',
                      width: 'auto',
                      backgroundColor: useColorModeValue('white', '#2d3748'),
                      borderRadius: '2vh',
                      display: 'inline-block',
                      paddingLeft: 10,
                      paddingRight: 10,
                    }}
                  >
                    CUT
                  </label>
                </div>
              </FormControl>
            </GridItem>
            
            <GridItem>
              <FormControl>
                <div
                  style={{
                    position: 'relative',
                    height: '50px',
                    marginTop: '5px',
                  }}
                >
                  <Input
                    id="rate"
                    type='number'
                    placeholder="Enter Rate"
                    value={currentRow?.rate || ''}
                    onChange={(e) =>
                      setCurrentRow({ ...currentRow, rate: e.target.value })
                    }
                    color={textColor}
                    bg={useColorModeValue('gray.100', '#2d3748')}
                    borderRadius="12px"
                    _placeholder={{ color: 'transparent' }}
                    fontSize="18px"
                    height="50px"
                    px="20px"
                    onFocus={() => handleFocus('rate')}
                    onBlur={handleBlur}
                  />
                  <label
                    htmlFor="rate"
                    style={{
                      position: 'absolute',
                      top:
                        focusedInput === 'rate' ||
                        (currentRow?.rate ? true : false)
                          ? '-10px'
                          : '15px',
                      left: '15px',
                      transform:
                        focusedInput === 'rate' ||
                        (currentRow?.rate ? true : false)
                          ? 'translateX(10px) scale(0.75)'
                          : 'translateX(0) scale(1)',
                      color: textColor,
                      transition: 'transform 200ms, color 200ms',
                      pointerEvents: 'none',
                      zIndex: 100,
                      height: '25px',
                      width: 'auto',
                      backgroundColor: useColorModeValue('white', '#2d3748'),
                      borderRadius: '2vh',
                      display: 'inline-block',
                      paddingLeft: 10,
                      paddingRight: 10,
                    }}
                  >
                    RATE
                  </label>
                </div>
              </FormControl>
            </GridItem>

            <GridItem>
              <FormControl>
                <div
                  style={{
                    position: 'relative',
                    height: '50px',
                    marginTop: '5px',
                  }}
                >
                  <Input
                    id="purrate"
                    type='number'
                    placeholder="Enter Purchase Rate"
                    value={currentRow?.purrate || ''}
                    onChange={(e) =>
                      setCurrentRow({ ...currentRow, purrate: e.target.value })
                    }
                    color={textColor}
                    bg={useColorModeValue('gray.100', '#2d3748')}
                    borderRadius="12px"
                    _placeholder={{ color: 'transparent' }}
                    fontSize="18px"
                    height="50px"
                    px="20px"
                    onFocus={() => handleFocus('purrate')}
                    onBlur={handleBlur}
                  />
                  <label
                    htmlFor="purrate"
                    style={{
                      position: 'absolute',
                      top:
                        focusedInput === 'purrate' ||
                        (currentRow?.purrate ? true : false)
                          ? '-10px'
                          : '15px',
                      left: '15px',
                      transform:
                        focusedInput === 'purrate' ||
                        (currentRow?.purrate ? true : false)
                          ? 'translateX(10px) scale(0.75)'
                          : 'translateX(0) scale(1)',
                      color: textColor,
                      transition: 'transform 200ms, color 200ms',
                      pointerEvents: 'none',
                      zIndex: 100,
                      height: '25px',
                      width: 'auto',
                      backgroundColor: useColorModeValue('white', '#2d3748'),
                      borderRadius: '2vh',
                      display: 'inline-block',
                      paddingLeft: 10,
                      paddingRight: 10,
                    }}
                  >
                    PUR RATE
                  </label>
                </div>
              </FormControl>
            </GridItem>

            <GridItem>
                <div
                  style={{
                    position: 'relative',
                    height: '50px',
                    marginTop: '15px',
                  }}
                >
              <label>STATUS</label>
              <Checkbox ml={10}>Inactive</Checkbox>
              </div>
            </GridItem>

            <GridItem colSpan={{base: 1,md: 2, xl: 2}}>
                  <FormControl>
                    <div
                      style={{
                        position: 'relative',
                        height: '50px',
                        marginBottom:20,
                        marginTop: '-15px',
                      }}
                    >
                      <Textarea
                        id="notes"
                        placeholder="Enter Notes"
                        value={currentRow?.notes || ''}
                        onChange={(e) =>
                          setCurrentRow({
                            ...currentRow,
                            notes: e.target.value,
                          })
                        }
                        color={textColor}
                        bg={useColorModeValue('gray.100', '#2d3748')}
                        borderRadius="12px"
                        _placeholder={{ color: 'transparent' }}
                        fontSize="18px"
                        height="50px"
                        px="20px"
                        onFocus={() => handleFocus('notes')}
                        onBlur={handleBlur}
                      />
                      <label
                        htmlFor="notes"
                        style={{
                          position: 'absolute',
                          top:
                            focusedInput === 'notes' ||
                            (currentRow?.notes ? true : false)
                              ? '-10px'
                              : '15px',
                          left: '15px',
                          transform:
                            focusedInput === 'notes' ||
                            (currentRow?.notes ? true : false)
                              ? 'translateX(10px) scale(0.75)'
                              : 'translateX(0) scale(1)',
                          color: textColor,
                          transition: 'transform 200ms, color 200ms',
                          pointerEvents: 'none',
                          zIndex: 100,
                          height: '25px',
                          width: 'auto',
                          backgroundColor: useColorModeValue(
                            'white',
                            '#2d3748',
                          ),
                          borderRadius: '2vh',
                          display: 'inline-block',
                          paddingLeft: 10,
                          paddingRight: 10,
                        }}
                      >
                        NOTES
                      </label>
                    </div>
                  </FormControl>
            </GridItem>

            <GridItem >
              <FormControl>
                <div
                  style={{
                    position: 'relative',
                    height: '50px',
                    marginTop: '5px',
                  }}
                >
                  <Input
                    id="colour"
                    placeholder="Enter Colour"
                    value={currentRow?.colour || ''}
                    onChange={(e) =>
                      setCurrentRow({ ...currentRow, colour: e.target.value })
                    }
                    color={textColor}
                    bg={useColorModeValue('gray.100', '#2d3748')}
                    borderRadius="12px"
                    _placeholder={{ color: 'transparent' }}
                    fontSize="18px"
                    height="50px"
                    maxLength={6}
                    px="20px"
                    onFocus={() => handleFocus('colour')}
                    onBlur={handleBlur}
                  />
                  <label
                    htmlFor="colour"
                    style={{
                      position: 'absolute',
                      top:
                        focusedInput === 'colour' ||
                        (currentRow?.colour ? true : false)
                          ? '-10px'
                          : '15px',
                      left: '15px',
                      transform:
                        focusedInput === 'colour' ||
                        (currentRow?.colour ? true : false)
                          ? 'translateX(10px) scale(0.75)'
                          : 'translateX(0) scale(1)',
                      color: textColor,
                      transition: 'transform 200ms, color 200ms',
                      pointerEvents: 'none',
                      zIndex: 100,
                      height: '25px',
                      width: 'auto',
                      backgroundColor: useColorModeValue('white', '#2d3748'),
                      borderRadius: '2vh',
                      display: 'inline-block',
                      paddingLeft: 10,
                      paddingRight: 10,
                    }}
                  >
                    COLOUR
                  </label>
                </div>
              </FormControl>
            </GridItem>

            <GridItem>
              <FormControl>
                <div
                  style={{
                    position: 'relative',
                    height: '50px',
                    marginTop: '5px',
                  }}
                >
                  <Input
                    id="weight"
                    placeholder="Enter Weight"
                    value={currentRow?.weight || ''}
                    onChange={(e) =>
                      setCurrentRow({ ...currentRow, weight: e.target.value })
                    }
                    color={textColor}
                    bg={useColorModeValue('gray.100', '#2d3748')}
                    borderRadius="12px"
                    _placeholder={{ color: 'transparent' }}
                    fontSize="18px"
                    height="50px"
                    type="number"
                    maxLength={6}
                    px="20px"
                    onFocus={() => handleFocus('weight')}
                    onBlur={handleBlur}
                  />
                  <label
                    htmlFor="weight"
                    style={{
                      position: 'absolute',
                      top:
                        focusedInput === 'weight' ||
                        (currentRow?.weight ? true : false)
                          ? '-10px'
                          : '15px',
                      left: '15px',
                      transform:
                        focusedInput === 'weight' ||
                        (currentRow?.weight ? true : false)
                          ? 'translateX(10px) scale(0.75)'
                          : 'translateX(0) scale(1)',
                      color: textColor,
                      transition: 'transform 200ms, color 200ms',
                      pointerEvents: 'none',
                      zIndex: 100,
                      height: '25px',
                      width: 'auto',
                      backgroundColor: useColorModeValue('white', '#2d3748'),
                      borderRadius: '2vh',
                      display: 'inline-block',
                      paddingLeft: 10,
                      paddingRight: 10,
                    }}
                  >
                    WEIGHT
                  </label>
                </div>
              </FormControl>
            </GridItem>

          </Grid>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={handleSave}
            variant="darkBrand"
            color="white"
            fontSize="sm"
            fontWeight="500"
            borderRadius="full"
            px="24px"
            py="5px"
            _active={{ bg: '#06b' }}
            mr={5}
            _focus={{ outlineColor: 'blue.500 ' }}
          >
            Save
          </Button>
          <Button variant="ghost" onClick={onClose} _focus={{ outlineColor: 'blue.500 ' }}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ScreenMasterForm;
